import { render, staticRenderFns } from "./Aggregazioni.vue?vue&type=template&id=c8fd099e&"
import script from "./Aggregazioni.vue?vue&type=script&lang=js&"
export * from "./Aggregazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports